<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container>
      <material-card
        icon="mdi-view-dashboard"
        color="primary"
        inline
        class="px-5 my-12 py-3"
        v-if="equipmentProfile"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("equipmentProfile.equipment") }}
            {{ equipmentProfile.equipTag }}
          </div>
        </template>
        <v-row>
          <v-col cols="12" md="6">
            <equipment-table
              :equipment-profile="equipmentProfile"
            ></equipment-table
          ></v-col>
          <v-col cols="12" md="6">
            <reliability-resume></reliability-resume>
          </v-col>
          <v-col cols="12"
            ><equipment-notifications></equipment-notifications
          ></v-col>
        </v-row>

        <v-divider class="my-8"></v-divider>
        <base-subheading
          class="text-capitalize"
          :subheading="$t('dashboard.conditionMonitoringModule')"
        />

        <equipment-charts></equipment-charts>
      </material-card> </v-container
  ></v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      unitRules: [v => !!v || "Unit is required"],
      areaRules: [v => !!v || "Area is required"],
      plantRules: [v => !!v || "Plant is required"],
      disabledAreas: true,
      disabledUnits: true,
      clientRules: [v => !!v || "Customer is required"],
      contract: [{ name: "Type A" }, { name: "Type B" }],
      status: [
        { name: "Active", value: true },
        { name: "Inactive", value: false }
      ]
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square",
      text: ""
    });
    try {
      await this.$store.dispatch(
        "equipments/bindAnEquipment",
        this.$route.params.id
      );
      await this.$store.dispatch("events/bindEvents", this.$route.params.id);
      await this.$store.dispatch(
        "reliabilities/bindLastReliability",
        this.$route.params.id
      );
    } catch (error) {
      this.$dialog.notify.error(error, {
        position: "top-right",
        timeout: 5000
      });
    } finally {
      loading.close();
    }
  },
  components: {
    "material-card": () => import("@/components/MaterialCard.vue"),
    "equipment-table": () => import("./EquipmentTable.vue"),
    "equipment-charts": () => import("./EquipmentCharts.vue"),
    "equipment-notifications": () => import("./EquipmentNotifications.vue"),
    "reliability-resume": () => import("./ReliabilityResume.vue")
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),

    isPump() {
      return this.equipmentProfile.isPump;
    }
  },

  methods: {}
};
</script>

<style scoped></style>
